import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'
import log from 'lib/log'
import { loadGroup, loadGroupMembers } from 'state/actions/groups'
const component = universal(props => import('./GroupMembersPage'))

class AsyncGroupMembersPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const {
      location: { type: place, payload: { group: groupId } },
      group: { value: { group, membership } = {} }
    } = getState()
    // make sure we have the group
    if (!group || group._id !== groupId) {
      try {
        let result = await loadGroup({ _id: groupId })(dispatch, getState, opts)
      } catch (e) {
        log.error(e)
      }
    }
    // and the membership info
    try {
      let result = await loadGroupMembers({ group: groupId })(
        dispatch,
        getState,
        opts
      )
    } catch (e) {
      log.error(e)
    }
  }
}

export default new AsyncGroupMembersPage()
